module.exports = __webpack_public_path__ + "static/img/emhyr_white.9d7b22a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/emhyr_white.png
// module id = 1Dri
// module chunks = 0